var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
// Entities
import { Talent } from 'packages/talent/entities/Talent';
import { Thread } from 'packages/email/entities/Thread';
// Components
import ThreadList from 'ui/v1/email/ThreadList.vue';
import MessageList from 'ui/v1/email/MessageList.vue';
import { Getter, namespace } from 'vuex-class';
import { Job } from 'packages/v3/jobs/Job';
import EmailComposer from '../email/EmailComposer.vue';
import { EmailAnalyticsData } from 'packages/email/EmailAnalyticsData';
import Icon from 'common/UIToolKit/Icon.vue';
var jobsModule = namespace('jobs');
var talentCardModule = namespace('talentCard');
var talentEmailModule = namespace('talentCard/talentEmailState');
var StatefulThreadBrowser = /** @class */ (function (_super) {
    __extends(StatefulThreadBrowser, _super);
    function StatefulThreadBrowser() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.emailAnalyticsData = new EmailAnalyticsData();
        _this.loading = false;
        _this.displayEmailComposer = false;
        _this.isReplying = false;
        return _this;
    }
    Object.defineProperty(StatefulThreadBrowser.prototype, "threadId", {
        get: function () {
            return this.selectedThread ? this.selectedThread.id : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatefulThreadBrowser.prototype, "threadSubject", {
        get: function () {
            var _a, _b, _c, _d;
            return ((_b = (_a = this.selectedThread) === null || _a === void 0 ? void 0 : _a.latestMessage) === null || _b === void 0 ? void 0 : _b.subject) || ((_d = (_c = this.selectedThread) === null || _c === void 0 ? void 0 : _c.messages[0]) === null || _d === void 0 ? void 0 : _d.subject);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatefulThreadBrowser.prototype, "candidates", {
        get: function () {
            return [this.talent];
        },
        enumerable: false,
        configurable: true
    });
    StatefulThreadBrowser.prototype.mounted = function () {
        var _this = this;
        this.setSelectedThread(this.threads.find(function (thread) { return thread.id === parseInt(_this.$route.query.threadId); }));
    };
    StatefulThreadBrowser.prototype.setThread = function () {
        this.setSelectedThread(this.threads[0]);
    };
    StatefulThreadBrowser.prototype.onReply = function () {
        this.isReplying = true;
        this.displayEmailComposer = true;
    };
    StatefulThreadBrowser.prototype.emailUpdated = function (templateEdited) {
        if (templateEdited) {
            this.emailAnalyticsData.setEmailTemplateEdited();
        }
        this.$emit('updated');
    };
    StatefulThreadBrowser.prototype.onNewEmail = function () {
        if (this.displayEmailComposer) {
            return;
        }
        this.isReplying = false;
        this.displayEmailComposer = true;
    };
    StatefulThreadBrowser.prototype.updateLatestMessage = function (message) {
        var _this = this;
        this.threads.find(function (thread) { var _a; return thread.id === ((_a = _this.selectedThread) === null || _a === void 0 ? void 0 : _a.id); }).latestMessage.readAt = message.readAt;
        this.setSelectedThreadLatestMessage(message);
    };
    StatefulThreadBrowser.prototype.sendEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var delayedThreadLoader;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.loading) {
                            return [2 /*return*/];
                        }
                        if (!this.emailComposer.isValid) {
                            this.emailComposer.$el.scrollIntoView();
                            return [2 /*return*/];
                        }
                        this.loading = true;
                        delayedThreadLoader = {
                            isSafeToCall: false,
                            shouldCallAfterDelay: false,
                            delayHandler: function () {
                                delayedThreadLoader.isSafeToCall = true;
                                if (delayedThreadLoader.shouldCallAfterDelay) {
                                    delayedThreadLoader.load();
                                }
                            },
                            load: function () {
                                if (!delayedThreadLoader.isSafeToCall) {
                                    delayedThreadLoader.shouldCallAfterDelay = true;
                                    return;
                                }
                                _this.loadThreads().then(function () { return _this.setThread(); });
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.emailComposer.send(this.selectedThread)];
                    case 2:
                        _a.sent();
                        this.$emit('sent');
                        this.emailComposer.sendPosthogEvent('sent');
                        this.displayEmailComposer = false;
                        // Thread re-loading should be delayed ~2 seconds after the email send request is completed.
                        setTimeout(delayedThreadLoader.delayHandler, 2000);
                        this.emailSentSuccess.open();
                        delayedThreadLoader.load();
                        return [3 /*break*/, 4];
                    case 3:
                        this.loading = false;
                        return [7 /*endfinally*/];
                    case 4:
                        this.emailAnalyticsData.reset();
                        return [2 /*return*/];
                }
            });
        });
    };
    StatefulThreadBrowser.prototype.loadThreads = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getThreads({
                            talentId: this.talentId,
                            jobId: this.candidateIsolationEnabledOrNil ? this.job.id : null,
                        })];
                    case 1:
                        _a.sent();
                        if (this.$router && this.$router.currentRoute.name === 'TalentCard.Email.New' || this.threads.length === 0) {
                            this.onNewEmail();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // If EmailComposer is open and one of the threads is selected, MessageList should appear instead of EmailComposer
    StatefulThreadBrowser.prototype.disableComposer = function () {
        if (!this.displayEmailComposer) {
            return;
        }
        this.displayEmailComposer = false;
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], StatefulThreadBrowser.prototype, "talentId", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", typeof (_a = typeof MessageList !== "undefined" && MessageList) === "function" ? _a : Object)
    ], StatefulThreadBrowser.prototype, "messageList", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", typeof (_b = typeof EmailComposer !== "undefined" && EmailComposer) === "function" ? _b : Object)
    ], StatefulThreadBrowser.prototype, "emailComposer", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], StatefulThreadBrowser.prototype, "emailSentSuccess", void 0);
    __decorate([
        Getter,
        __metadata("design:type", Boolean)
    ], StatefulThreadBrowser.prototype, "candidateIsolationEnabledOrNil", void 0);
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_c = typeof Job !== "undefined" && Job) === "function" ? _c : Object)
    ], StatefulThreadBrowser.prototype, "job", void 0);
    __decorate([
        talentCardModule.State,
        __metadata("design:type", typeof (_d = typeof Talent !== "undefined" && Talent) === "function" ? _d : Object)
    ], StatefulThreadBrowser.prototype, "talent", void 0);
    __decorate([
        talentEmailModule.State,
        __metadata("design:type", Array)
    ], StatefulThreadBrowser.prototype, "threads", void 0);
    __decorate([
        talentEmailModule.State,
        __metadata("design:type", typeof (_e = typeof Thread !== "undefined" && Thread) === "function" ? _e : Object)
    ], StatefulThreadBrowser.prototype, "selectedThread", void 0);
    __decorate([
        talentEmailModule.Mutation,
        __metadata("design:type", Function)
    ], StatefulThreadBrowser.prototype, "setSelectedThread", void 0);
    __decorate([
        talentEmailModule.Mutation,
        __metadata("design:type", Function)
    ], StatefulThreadBrowser.prototype, "setSelectedThreadLatestMessage", void 0);
    __decorate([
        talentEmailModule.Action,
        __metadata("design:type", Function)
    ], StatefulThreadBrowser.prototype, "getThreads", void 0);
    __decorate([
        Watch('selectedThread', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], StatefulThreadBrowser.prototype, "disableComposer", null);
    StatefulThreadBrowser = __decorate([
        Component({
            components: {
                EmailComposer: EmailComposer,
                ThreadList: ThreadList,
                MessageList: MessageList,
                Icon: Icon,
            },
        })
    ], StatefulThreadBrowser);
    return StatefulThreadBrowser;
}(Vue));
export default StatefulThreadBrowser;
